<template>
	<div>
        <Loading :value="loading"></Loading>

        <v-dialog v-model="dialogDemande" width="80%" :persistent="true"  transition="dialog-bottom-transition" scrollable>
            <v-card tile>

                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Effectuer une demande de réparation</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <el-form id="formInterv"  :model="intervDetail" :rules="rules" ref="formIntervention" class="demo-form-inline">
                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                                <el-form-item label="Vehicule concerné" prop="vehicule">
                                    <el-select filterable clearable v-model="intervDetail.idVeh" @change="selectChauffeur(intervDetail.idVeh)"  placeholder="Vehicule concerné" style="width:100%" >
                                        <el-option v-for="item in listVehicule" :key="item.idVeh" :label="item.libelle" :value="item.idVeh">
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                            </v-flex>
                              <v-flex xs3 class="mr-1" >
                                <el-form-item label="Chauffeur" prop="chauffeur">
                                    <el-input  size="large" disabled  v-model="intervDetail.Chauffeur" placeholder=""  style="width:100%"></el-input>
                            </el-form-item>
                            </v-flex>

                             <v-flex xs3 class="mr-1" >
                                <el-form-item label="Categorie" prop="categorie">
                                <el-select filterable clearable v-model="intervDetail.categorie" placeholder="Catégorie" style="width:100%" >
                                    <el-option v-for="item in categorie" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            </v-flex>
                            <v-flex xs3 class="mr-1" >
                                <el-form-item label="Type de demande" prop="type">
                                 <el-select clearable v-model="intervDetail.type" placeholder="Type de demande" style="width:100%" >
                                    <el-option v-for="item in typeDemande" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                                </el-form-item>
                              </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                                <el-form-item label="Gravité" prop="gravite">
                                    <el-select clearable v-model="intervDetail.gravite" placeholder="Gravité" style="width:100%" >
                                        <el-option v-for="item in gravite" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                 </el-form-item>
                            </v-flex>
                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Priorité" prop="priorite">
                                    <el-select clearable v-model="intervDetail.priorite" placeholder="Priorité" style="width:100%" >
                                        <el-option v-for="item in priorite" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                             </v-flex>

                            <v-flex xs4>
                             <el-form-item label="Date de la demande" prop="date">
                                <el-date-picker v-model="intervDetail.dateFormat" format="d-MM-yyyy HH:mm" value-format="yyyy-MM-d HH:mm" name="date" type="datetime" placeholder="Date de la demande" style="width:100%" ></el-date-picker>
                            </el-form-item>
                            </v-flex>

                        </v-layout>


                        <v-layout row>
                            <v-flex xs4 class="mr-1">
                                <el-form-item label="Nom du demandeur" prop="demandeur">
                                    <el-autocomplete  v-model="intervDetail.demandeur" name="demandeur" placeholder="nom du demandeur"  style="width: 100%" :fetch-suggestions="loadDemandeur" ></el-autocomplete>
                                </el-form-item>
                            </v-flex>
                              <v-flex xs4 class="mr-1">
                                <el-form-item label="Télephone du demandeur" prop="telephone">
                                    <el-input  type="text" v-model="intervDetail.telephone" name="telephone" placeholder="Téléphone du demandeur"  style="width: 100%"></el-input>
                                </el-form-item>
                            </v-flex>
                            <v-flex xs4 class="mr-1"   >
                            <el-form-item label="Projet" prop="projet">
                                <el-select  v-model="intervDetail.projet" name="projet" placeholder="projet" style="width: 100%" @change="selectProjet" >
                                    <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                                    </el-form-item>
                            </v-flex>

                     <v-flex xs4 class="mr-2" >
                            <el-form-item label="Chantier" prop="chantier">
                                <el-select  v-model="intervDetail.chantier" name="chantier" placeholder="chantier" style="width: 100%">
                                    <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                    </v-flex>


                        </v-layout>

                         <v-layout row>
                              <v-flex xs4>
                             <el-form-item label="Description" prop="motif">
                                <el-input type="textarea" name="motif" placeholder="description" v-model="intervDetail.motif" style="width:100%" required></el-input>
                            </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="ml-3" >
                                  <el-form-item label="" prop="">
                                 <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="imageDmdInterv" alt="avatar"></v-avatar>
                                 <v-layout row>
                                    <input name="imageDmdInterv" type="file" style="display:none" ref="fileDmdInterv" accept="image/*" @change="onFileImageDmdIntervPicked"/>
                                        <v-btn color="primary" class="white--text" required @click.native="$refs.fileDmdInterv.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                        <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 2 Mo maximale</div>
                                </v-layout>
                                 </el-form-item>
                            </v-flex>
                         </v-layout>

                        <v-layout row >
                            <v-flex xs12  class="mt-2" >
                            <el-form-item  class="text-xs-right" >
                               <v-btn color="grey"  @click="closeDialog()" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                               <v-btn  icons dark color="green" @click="submitIntervention('formIntervention')">Enregistrer<v-icon right>save</v-icon></v-btn>

                            </el-form-item>
                            </v-flex>
                        </v-layout>
                    </el-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "AjoutIntervention",
        props:
        {
            show: {
                type: Boolean,
                default: false
            },
            intervDetail: {
                type: Object,
            },
            editForm:{
                type: Boolean,
                default: false
            }
        },

        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            labelPosition: 'left',
            dialogDemande: false,
             typeDemande: [
                    { value: 'Réparation', label: 'Réparation'},
                    { value: 'Maintenance', label: 'Maintenance'}
                ],
             gravite: [
                    { value: 'Moins grave', label: 'Moins grave'},
                    { value: 'Grave', label: 'Grave'},
                    { value: 'Très grave', label: 'Très grave'}
                ],
                priorite: [
                    { value: 'Moins urgent', label: 'Moins urgent'},
                    { value: 'Urgent', label: 'Urgent'},
                    { value: 'Très urgent', label: 'Très urgent'}
                ],
            listVehicule: [],
                   categorie: [
                    { value: 'Carrosserie', label: 'Carrosserie'},
                    { value: 'Lavage', label: 'Lavage'},
                    { value: 'Parallélisme', label: 'Parallélisme'},
                    { value: 'Pneumatique', label: 'Pneumatique'},
                    { value: 'Réparation', label: 'Réparation'},
                    { value: 'Vidange', label: 'Vidange'},
                    { value: 'Mécanique', label: 'Mécanique'},
                    { value: 'Peinture', label: 'Peinture'},
                    { value: 'Tolérie', label: 'Tolérie'},
                    { value: 'Electrique', label: 'Electrique'},
                    { value: 'Autre', label: 'Autre'}
                ],
            rules: {
                idVeh: [
                    { required: true, message: 'Veuillez selectionner' },
                ],
                 categorie: [
                    { required: true, message: 'Veuillez selectionner' },
                ],
                 telephone: [
                    { required: true, message: 'Veuillez saisir un numero' },
                ],
                 demandeur: [
                    { required: true, message: 'Veuillez saisir le nom du demandeur' },
                ],
                dateFormat: [
                    { required: true, message: 'Veuillez selectionner une date', trigger: 'blur'},
                ],
                 priorite: [
                    { required: true, message: 'Veuillez selectionner'},
                ],
                type: [
                    { required: true, message: 'Veuillez selectionner', trigger: 'blur' },
                ],
                 gravite: [
                    { required: true, message: 'Veuillez selectionner', trigger: 'blur' },
                ]
            },
             imageDmdInterv: "/static/img-doc.png",
             fileDmdInterv: "",
             listeProjet: [],
             listeChantier: []
         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDemande = newValue
               this.loadVehicule ()
               if(newValue == true){
                   this.loadProjet();
                   if(this.editForm == true){

                   }
                   else {
                       this.imageDmdInterv = "/static/img-doc.png";
                   }
               }else {
                   this.formDemande = {}
               }
            }
        },

        methods: {

              selectProjet(idProjet)
         {
            this.listeChantier.splice(0);
            this.intervDetail.chantier = '';
             this. loadChantier (idProjet)
         },

          loadProjet () {
              let url = this.domaine + 'projet/index/projet/all'

              this.loading = true
              this.$http.get(url).then(response => {
                  this.loading = false
                      this.listeProjet = response.body.projet


              },errRep=>{
                   this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
              })
          },
            loadChantier (item)
            {
              this.loading =  true
             //this.formDmd.chantier = '';
              let url = this.domaine + 'projet/'+ item +'/index/chantier'
              this.$http.get(url).then(response => {
                  this.loading = false
                  this.listeChantier = response.body.chantier
              },errRep=>{
                   this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la liste du chntier")
              })
          },

             loadVehicule () {
                this.loading = true
                let url = this.domaine + 'parc/index'
                this.$http.get(url).then(response => {
                        this.listVehicule = response.body.vehicule
                        this.loading = false
                },errRep => {
                    this.$message.error("Une erreur est survenue lors du chargement de la liste de vehicule")
                    this.loading = false
                })
            },
             createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
             closeDialog(){
                this.$emit('close')
            },
            submitIntervention(formName)
            {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                  if(this.intervDetail.demandeur == undefined){
                    this.$message.error("Veuillez saisir ou selectionner le demandeur");
                    return
                }
                this.loading = true
                let formInterv = document.getElementById('formInterv')
                let url = this.domaine + 'intervention/new/intervention';
                        let data = new FormData(formInterv)
                        data.append('idUser', this.user.id)
                        //data.append('etape', etape)
                        data.append('type', this.intervDetail.type)
                        data.append('priorite', this.intervDetail.priorite)
                        data.append('gravite', this.intervDetail.gravite)
                        data.append('categorie', this.intervDetail.categorie)
                        data.append('demandeur', this.intervDetail.demandeur)
                        data.append('telephone', this.intervDetail.telephone)
                        if(this.intervDetail.chantier != undefined || this.intervDetail.chantier != "" )
                        {
                            data.append('chantier', this.intervDetail.chantier)
                        }

                        data.append('vehicule', this.intervDetail.idVeh)
                        data.append('motif', this.intervDetail.motif)
                        data.append('dateInter', this.intervDetail.dateFormat)
                        if( this.intervDetail.id  )
                        {
                            data.append('id', this.intervDetail.id  )
                        }
                        else
                        {
                            data.append('id', '')
                        }

                 this.$http.post(url, data).then(response => {
                     //reinitialiser le formulaire
                     this.resetForm('formIntervention')
                     this.loading = false
                     this.successNotif(response.body.message)
                     this.closeDialog()
                },
                (erreur) => {
                    //reinitialiser le formulaire
                     this.resetForm('formIntervention')
                     this.closeDialog()
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors de l'enregistrement de la l'intervention")
                    })
                 }
                });
            },
            selectChauffeur(idVeh){              
              this.listVehicule.find((item)=>{                
                if(idVeh == item.idVeh){
                  this.intervDetail.Chauffeur= item.conducteur ? item.conducteur : 'Aucun chauffeur'
                }
              })                
            },
             loadDemandeur(queryString, cb) {
            let url = this.domaine +  'mission/listes-employe'
            var formdata = new FormData();
            formdata.append('user', this.user.id)
            formdata.append('tag', queryString)
            this.$http.post(url, formdata).then(response => {
                    if (response.body) {
                        var links = response.body;
                        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                        cb(results);
                    }
                },
                response => {
                })
            },

        createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

        successNotif(mess = ""){
            this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
            })
        },
        //enregistrement des images
        onFileImageDmdIntervPicked(event)
        {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf(".") <= 0)
            {
                return alert("Veuillez selectionner un  format de fichier valide ")
            }

            const fileReader = new FileReader()
            fileReader.addEventListener("load", () => {
                this.imageDmdInterv = fileReader.result
            })

            this.imageDmdInterv = files[0]
            fileReader.readAsDataURL(files[0])
            this.fileDmdInterv = files[0]
        },
    },
    mounted(){}

    }
    </script>



// WEBPACK FOOTER //
// src/components/intervention/AjoutIntervention.vue